import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Page, LayoutSideNavigation, UserNav } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useConfiguration } from '../../context/configurationContext';
import { ensureCurrentUser } from '../../util/data';
import { showCreateListingLinkForUser, getCurrentUserTypeRoles } from '../../util/userHelpers';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import TrackBalancePanel from './TrackBalancePanel';
import { fetchVouchersByEmail } from './TrackBalancePage.duck';
import css from './TrackBalancePage.module.css';

const TrackBalancePageComponent = props => {
  const config = useConfiguration();
  const { currentUser, scrollingDisabled, voucherData, userVouchers, fetchingUserVouchers, onFetchVouchersByEmail } = props;

  const user = ensureCurrentUser(currentUser);
  const showManageListingsLink = showCreateListingLinkForUser(config, user);
  const { customer: isCustomer, provider: isProvider } = getCurrentUserTypeRoles(config, user);
  const inboxTab = !isCustomer ? 'sales' : !isProvider ? 'orders' : 'sales';

  // Fetch vouchers for logged-in user automatically
  useEffect(() => {
    if (currentUser && currentUser.attributes && currentUser.attributes.email) {
      const userEmail = currentUser.attributes.email;
      onFetchVouchersByEmail(userEmail);
    }
  }, [currentUser, onFetchVouchersByEmail]);

  return (
    <Page className={css.root} title="Track Balance" scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer desktopClassName={css.desktopTopbar} mobileClassName={css.mobileTopbar} />
            {currentUser && (
              <UserNav
                currentPage="TrackBalancePage"
                showManageListingsLink={showManageListingsLink}
                inboxTab={inboxTab}
              />
            )}
          </>
        }
        sideNav={null}
        useAccountSettingsNav={false}
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <TrackBalancePanel 
            voucherData={voucherData}
            userVouchers={userVouchers}
            fetchingUserVouchers={fetchingUserVouchers}
            currentUser={currentUser}
          />
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
  scrollingDisabled: isScrollingDisabled(state),
  voucherData: state.TrackBalancePage.voucherData,
  userVouchers: state.TrackBalancePage.userVouchers,
  fetchingUserVouchers: state.TrackBalancePage.fetchingUserVouchers,
});

const mapDispatchToProps = dispatch => ({
  onFetchVouchersByEmail: email => dispatch(fetchVouchersByEmail(email)),
});

const TrackBalancePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackBalancePageComponent);

export default TrackBalancePage;
